'use client';

import LanguageSwitcher from '@/components/blocks/LanguageSwitcher';
import LogoutButton from '@/components/blocks/LogoutButton';
import Image from '@/components/Image';
import { PathEnum } from '@/i18n/locale-config';
import { Link } from '@/i18n/navigation';
import { useUserStore } from '@/store/useUserStore';
import { ArrowLeft } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';

const AuthHeader = () => {
    const t = useTranslations();
    const { session, user } = useUserStore();

    const isLoggedIn = session && user;

    const [hydrated, setHydrated] = useState<boolean>(false);
    useEffect(() => {
        setHydrated(true);
    }, []);

    if (!hydrated) return null;

    return (
        <header className="flex justify-between items-start text-white">
            <div>
                <Link href={PathEnum.Home}>
                    <Image
                        src="/img/logotype.svg"
                        alt="Image+Nation"
                        width={200}
                        height={200}
                        className="w-24 h-24 md:w-36 md:h-36 md:min-w-36 md:min-h-36 [@media_(max-height:820px)]:w-24 [@media_(max-height:820px)]:min-w-24 [@media_(max-height:820px)]:h-24 [@media_(max-height:820px)]:min-h-24"
                    />
                </Link>
                <Link
                    href={PathEnum.Home}
                    className="my-7 flex items-center gap-2.5 uppercase text-lg hover:text-primary transition-colors duration-300"
                >
                    <ArrowLeft className="text-pink-light" />
                    {t('Common.goBack')}
                </Link>
                {isLoggedIn && (
                    <div className="max-lg:hidden">
                        <LogoutButton />
                    </div>
                )}
            </div>
            <LanguageSwitcher />
            {isLoggedIn && (
                <div className="lg:hidden -translate-y-1">
                    <LogoutButton />
                </div>
            )}
        </header>
    );
};

export default AuthHeader;
